import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";
import { DaySelection } from "./daySelection";
import moment from "moment";
import { format } from "../../../heplers/format";

const useStyles = makeStyles(() => ({
	wrapper: {
		background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
		borderRadius: "16px",
		padding: "20px 24px",
		boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
		border: "1px solid #e8edf2",
	},
}));

// params.selectedDate is a Date or an "MM-DD-YYYY" string; the day bar uses "DD-MM-YYYY"
const toDayKey = (value) =>
	(value instanceof Date ? moment(value) : moment(value, ["MM-DD-YYYY", moment.ISO_8601])).format("DD-MM-YYYY");

const Filtration = memo(({ params, setParams }) => {
	const classes = useStyles();
	// follows the page's date, so a date set by the page (e.g. a reservation opened from a link) is shown too
	const selectedDate = params?.selectedDate ? toDayKey(params.selectedDate) : format("date", new Date());

	return (
		<div >
			<DaySelection
				selectedDate={selectedDate}
				setSelectedDate={(value) => {
					setParams({
						...params,
						selectedDate: moment(value, "DD-MM-YYYY").format("MM-DD-YYYY"),
						day: new Date(value).getDay(),
					});
				}}
			/>
		</div>
	);
});

export default Filtration;
